<template>
<template v-doctitle="category"></template>
<div class="card float-e-margins">
  <div class="card-title">
      <h1 v-if="$route.params.id != 20">{{ category }}</h1>
  </div>
  <div class="card-content">
  <!-- Title and image Sold Out -->
    <div class="row" v-if="$route.params.id == 20">
      <div class="col-md-12 text-center">
        <img v-else class="img-responsive center-block" src="../assets/img/verkocht1.jpg" style="max-height:200px;margin: 0 auto;">
        <h1 class="center-block">Jammer...  maar helaas verkocht!!</h1>
      </div>
    </div>
    <!-- Loader -->
    <div class="row" v-if="!loaded">
      <div class="col-xs-2 col-xs-offset-5">
        <img v-else class="img-responsive" src="../assets/img/ajax_loader.gif" style="max-height:50px;">
        <div class="pull-left">
          <p>Laden..</p>
        </div>
      </div>
    </div>
    <!-- List Products -->
    <div class="row" v-else>
      <div v-for="product in products" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <product-card :product="product" ></product-card>
      </div>

    <!-- Begin Submenu -->
    <div class="row category-credit" v-if="loaded">
      <div v-for="submenu in store.selectedCat.Children" class="col-lg-3 col-md-4 col-sm-6 col-xs-12" style="max-height:320px">
        <div class="thumbnail">
            <div class="wrapper">
              <div class="caption post-content">
                <a v-link="{ name: 'categorie', params: { id: submenu.MenuItemId, cname: $options.filters.slugurl(submenu.MenuText)}}">
                  <h3>{{submenu.MenuText}}</h3>
                </a>
              </div>
            </div>
          <div class="wrapper">
              <div class="post-meta">
                  <div class="price"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import store from '../store'
import ProductCard from '../components/Common/ProductCard'
export default {
  route: {
    canReuse: false
  },
  components: {
    ProductCard
  },
  data () {
    return {
      store: store,
      products: {},
      category: '',
      loaded: false
    }
  },
  methods: {
  },
  ready () {
  },
  created () {
    $.ajax({
      type: 'GET',
      url: store.root + 'api/products/category/' + this.$route.params.id,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        this.loaded = true
        this.category = response.Category
        this.products = response.Products
      }.bind(this)
    })
  }
}
</script>

<style scoped>
  @media screen and (max-width: 768px){
    p{
      font-size: 3.2vw;
    }
  }
</style>


// WEBPACK FOOTER //
// Categorie.vue?10a042f4